'use strict';
import { getLogger } from 'loglevel';
import * as globalisation from '../../utilities/globalisation';
import MarketingTracking from '../MarketingTracking/MarketingTracking';

const log = getLogger('RegistrationConfirmationModal')

var _ = require('underscore'),
  $ = require('jquery'),
  mediator = require('../../js/mediator'),
  ModalView = require('../../js/components/ModalView'),
  registrationModalTemplate = require('./templates/_RegistrationConfirmationModal.hbs'),
  events = require('../../js/config').events,
  RegistrationModalView,
  config = require('../../js/config'),
  LoginAPI = require('../Login/LoginAPI'),
  featureFlags = require('../../utilities/featureFlags'),

  RegistrationModalView = ModalView.extend({
    template: registrationModalTemplate,
    goTo: null,
    goToOnFail: null,
    email: null,
    firstName: null,
    lastName: null,
    optIn: null,
    privacyTermsOptIn: null,
    country: null,
    phoneNumber: null,
    companyName: null,
    companyWebsite: null,
    jobType: null,
    industry: null,
    business: null,
    businessServed: null,
    password: null,
    events: {
      'submit #autoLoginForm': 'onClose',
      'click button[type="submit"]': 'onClose'
    },
    initialize: function() {
      this.MarketingTracking = new MarketingTracking();
      RegistrationModalView.__super__.initialize.apply(this, arguments);
      this.verifiedEmail = document.getElementsByClassName('RegistrationForm-email')[0].textContent;
      mediator.on(events.registration.confirmation, this.open);
    },

    open: function(data) {
      this.modalData = data;
      this.render();
      this.modal.open();
      this.goTo = data.goTo;
      this.goToOnFail = data.goToOnFail;
      this.email = data.emailId;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.optIn = data.optIn;
      this.privacyTermsOptIn = data.privacyTermsOptIn;
      this.country = data.country;
      if (featureFlags.EnableEUCFields.isEnabled()) {
        this.phoneNumber = data.phoneNumber;
        this.companyName = data.companyName;
        this.companyWebsite = data.companyWebsite;
        this.jobType = data.jobType;
        this.industry = data.industry;
        this.business = data.business;
        this.businessServed = data.businessServed;
      }
      this.password = data.password;
      this.$modalContainer = $('.RegistrationModal-modalDialog');

      // encode # for IE :(
      if (this.goTo.indexOf('#') > 0) {
        this.goTo = this.goTo.replace('#', '%23');
      }

      // Advanced form hide all shortForm classes from the modal
      if (data.advancedForm) {
        this.$modalContainer.addClass('isLongForm');
      }
      this.formatAutoLoginForm();
      // Fix for the overlay disappearing when another dialog
      // is opened before the first gets a chance to close
      _.delay(_.bind(function() {
        this.modal.$overlay.show();
      }, this), 200);
    },
    goToRedirectUrl: function goToRedirectUrl() {
      $('[name="goToRedirectUrl"]').addClass('loading');
      window.location.href = this.goTo;
    },
    submitForm: function submitForm() {
      $('[name="loginUser"]').addClass('loading');
      sessionStorage.setItem(config.sessionVariables.marketingTracking.userJustTriedToRegisterCookie, JSON.stringify({
        email: this.verifiedEmail,
        firstName: this.firstName,
        lastName: this.lastName,
        optIn: this.optIn,
        privacyTermsOptIn: this.privacyTermsOptIn,
        country: this.country
      }));
      this.MarketingTracking.initializeUserRegistrationTracking();
      if (featureFlags.RegistrationAutoLogin.isEnabled()) {
        let response = LoginAPI.login(this.verifiedEmail, this.password);
        response.then(_.bind((data) => {
          if (data.success) {
            let allRequests = LoginAPI.getCrossDomainLogin(data);
            Promise.all(allRequests)
              .then(() => {
                log.info('Crossdomainlogin succeeded');
                window.location.href = this.goTo;
              })
              .catch(err => log.error('Crossdomain failed' + err));
          } else {
            window.dataLayer.push({
              event: 'Register', eventframework: {
                category: 'Register', action: 'Arrow.com', label: 'Fail', value: undefined,
                formFailureReason: 'Server side-' + globalisation.pluraliseAndTranslate('account', 'crossDomainError')
              }
            });
            window.location.href = this.goToOnFail;
          }
        }, this));
      } else {
        $('[name="autoLoginForm"]').submit();
      }
    },
    onOpen: function onOpen() {
      // make sure if user hits enter when dialog opens it will use whichever submit button is visible
      this.$el.find('.RegistrationModal-modalButton:visible').focus();
    },
    onClose: function onClose(e) {
      e.preventDefault();
      this.submitForm();
    },
    formatAutoLoginForm: function formatAutoLoginForm() {
      this.$modalContainer.addClass('isAutoLogin');
      $('[name="IDToken1"]').val(this.verifiedEmail);
      $('[name="IDToken2"]').val(this.password);
      $('[name="goto"]').val(decodeURIComponent(this.goTo));
      $('[name="gotoOnFail"]').val(this.goToOnFail);
      $('.autoLogin').attr('action', config.urls.login.openAMLoginUrl);
    }
  });

module.exports = RegistrationModalView;



// WEBPACK FOOTER //
// ./assets/components/Registration/RegistrationConfirmationModal.js